import React from "react";
import { useSelector } from "react-redux";
import {
  getElementById,
  getContainerClass,
  getLabelStyles,
  getInputStyles,
} from "../utils/styleUtils";

export const CustomCheckbox = ({ instanceId, field, form, ...props }) => {
  const formBuilder = useSelector((state) => state.customFormBuilder);
  const element = getElementById(instanceId, formBuilder);

  if (!element) {
    return <div>Checkbox element not found</div>;
  }

  const elementStyle = element.style || {};
  const labelPosition = elementStyle.labelPosition || "right"; // Default to right for checkboxes

  const handleInputChange = (e) => {
    if (field && form) {
      form.setFieldValue(field.name, e.target.checked);
    }
  };

  const getCheckboxStyles = () => {
    return {
      width: elementStyle.checkboxSize || "1.125rem",
      height: elementStyle.checkboxSize || "1.125rem",
      accentColor: elementStyle.checkboxColor || "#0d6efd",
      cursor: "pointer",
      marginRight: labelPosition === "right" ? "0.5rem" : "0",
      marginLeft: labelPosition === "left" ? "0.5rem" : "0",
    };
  };

  return (
    <div className={getContainerClass(labelPosition)} style={{ width: "100%" }}>
      {labelPosition === "top" && elementStyle.label?.label && (
        <label
          htmlFor={`checkbox-${instanceId}`}
          style={getLabelStyles(elementStyle, labelPosition)}
        >
          {elementStyle.label.label}
          {elementStyle.isRequired && (
            <span style={{ color: "#dc3545", marginLeft: "0.2rem" }}>*</span>
          )}
        </label>
      )}

      <div
        className="d-flex align-items-center"
        style={
          labelPosition === "top" || labelPosition === "bottom"
            ? {}
            : { width: "100%" }
        }
      >
        {labelPosition === "left" && elementStyle.label?.label && (
          <label
            htmlFor={`checkbox-${instanceId}`}
            style={{
              ...getLabelStyles(elementStyle, labelPosition),
              cursor: "pointer",
              marginRight: "0.5rem",
            }}
          >
            {elementStyle.label.label}
            {elementStyle.isRequired && (
              <span style={{ color: "#dc3545", marginLeft: "0.2rem" }}>*</span>
            )}
          </label>
        )}

        <input
          id={`checkbox-${instanceId}`}
          type="checkbox"
          checked={field?.value || false}
          onChange={handleInputChange}
          required={elementStyle.isRequired}
          style={getCheckboxStyles()}
          className="form-check-input"
          {...props}
        />

        {labelPosition === "right" && elementStyle.label?.label && (
          <label
            htmlFor={`checkbox-${instanceId}`}
            style={{
              ...getLabelStyles(elementStyle, labelPosition),
              cursor: "pointer",
              marginLeft: "0.5rem",
            }}
          >
            {elementStyle.label.label}
            {elementStyle.isRequired && (
              <span style={{ color: "#dc3545", marginLeft: "0.2rem" }}>*</span>
            )}
          </label>
        )}
      </div>

      {labelPosition === "bottom" && elementStyle.label?.label && (
        <label
          htmlFor={`checkbox-${instanceId}`}
          style={{
            ...getLabelStyles(elementStyle, labelPosition),
            cursor: "pointer",
          }}
        >
          {elementStyle.label.label}
          {elementStyle.isRequired && (
            <span style={{ color: "#dc3545", marginLeft: "0.2rem" }}>*</span>
          )}
        </label>
      )}

      {elementStyle.helpText && (
        <small className="text-muted mt-1" style={{ fontSize: "0.75rem" }}>
          {elementStyle.helpText}
        </small>
      )}
    </div>
  );
};
